export enum EnumBidResult {
  Success = 1,
  NoPaymentMethod = 2,
  Error = 3
}